export default "__VITE_ASSET__D_v9B4t9__"